import { compile } from "@thi.ng/vectors/compile/emit";
import { SET } from "@thi.ng/vectors/compile/templates";
import { set as _set, set4 } from "@thi.ng/vectors/set";
const $ = (dim) => _set.add(dim, compile(dim, SET, "o,a", void 0, "o"));
const set = _set;
const set22 = set4;
const set23 = $(6);
const set33 = $(9);
const set44 = $(16);
export {
  set,
  set22,
  set23,
  set33,
  set44
};
